import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../../../firebase';
import { useSchool } from '../../../contexts/SchoolContext';

export default function GmailAuthPrompt() {
  const { schoolId } = useSchool();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConnect = async () => {
    setLoading(true);
    setError(null);
    try {
      const initiate = httpsCallable(functions, 'gmailOAuthInitiate');
      const result = await initiate({ schoolId });
      const { authUrl } = result.data;
      window.location.href = authUrl;
    } catch (err) {
      setError(err.message || 'Failed to connect Gmail');
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-full p-6 text-center gap-4">
      <div className="text-4xl">✉️</div>
      <h3 className="text-lg font-semibold">Connect Gmail</h3>
      <p className="text-sm text-base-content/60 max-w-xs">
        Connect your Gmail account to see emails from parents directly in Swan.
        Swan requests <strong>read and send</strong> access to your Gmail.
      </p>
      {error && (
        <div className="alert alert-error text-sm py-2">{error}</div>
      )}
      <button
        className="btn btn-primary"
        onClick={handleConnect}
        disabled={loading}
      >
        {loading ? <span className="loading loading-spinner loading-sm" /> : null}
        Connect Gmail
      </button>
    </div>
  );
}
